import { useEffect, useRef, useState } from 'react';

export const LazyVideo = ({ videoSrc, setIsPlayed, isMuted, isPlayed }) => {
  const containerRef = useRef(null);
  const videoRef = useRef(null);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  // 🔇 Gérer le mute
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = isMuted;
    }
  }, [isMuted]);

  // ▶️ Gérer la lecture / pause depuis le parent
  useEffect(() => {
    if (videoRef.current) {
      if (isPlayed) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [isPlayed]);

  // Clic manuel sur la vidéo
  const handleVideoClick = () => {
    if (videoRef.current) {
      const playing = !videoRef.current.paused;
      if (playing) {
        videoRef.current.pause();
        setIsPlayed(false);
      } else {
        videoRef.current.play();
        setIsPlayed(true);
      }
    }
  };

  return (
    <div ref={containerRef} className="w-full h-screen">
      {isVisible && (
        <video
          ref={videoRef}
          className="h-screen w-full object-cover cursor-pointer"
          playsInline
          controlsList={"nofullscreen"}
          autoPlay
          loop
          muted={isMuted}
          onClick={handleVideoClick}
        >
          <source src={`${videoSrc}.webm`} type="video/webm" />
          <source src={`${videoSrc}.mp4`} type="video/mp4" />
        </video>
      )}
    </div>
  );
};